<template>
  <div class="view box grow" style="overflow-y: auto;">
    <page-headers
      :header="'Threat Progressions'"
      :breadcrumbs="breadcrumbs"
      :is-border="true"
      documentation="page-progressions"
      class="box"
    >
      <div slot="actions" class="float-right">
        <!-- <date-range-dropdown
          :disable-selection="isTrailsLoading"
          :store-pref-constant="daterangeUserPrefConstant"
          :date-range-val="trailProgressionDateRangeUserSetting"
        ></date-range-dropdown> -->
      </div>
    </page-headers>
    <el-tabs v-model="activeView" @tab-click="goto">
      <el-tab-pane label="Active Progressions" name="active"></el-tab-pane>
      <el-tab-pane label="Mitigated Progressions" name="mitigated"></el-tab-pane>
    </el-tabs>
    <router-view class="box grow"></router-view>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

import { AttackTrailStateEnum } from "@/constants/trail-state.constants";
import PageHeaders from "@/components/layout/PageHeaders.vue";
import DateRangeDropdown from "@/components/dropdown/DateRangeDropdown.vue";
import { THREAT_PROGRESSION_DATE_RANGE_PREFERENCE } from "@/store/modules/user_pref/user-pref.type";

export default {
  name: "BaseCyberAttacks",
  data() {
    return {
      daterangeUserPrefConstant: THREAT_PROGRESSION_DATE_RANGE_PREFERENCE,
      activeView: "active",
      collapseRightNav: true,
      openSidebar: false,
      breadcrumbs: [{ title: "Threats" }, { title: "Progressions" }]
    };
  },
  beforeMount() {
    // If window refreshed, stay on previous rules page
    if (performance.navigation.type === 1) {
      this.$router.push({
        path: this.$route.path,
        query: this.$route.query,
        params: this.$route.params
      });
      this.activeView = this.$route.path.split("/").reverse()[0];
    } else {
      // set default path for threat progression
      this.$router.push({
        path: this.routePath,
        query: this.$route.query,
        params: this.$route.params
      });
    }
  },
  methods: {
    goto({ name }) {
      this.$router.push({
        name: AttackTrailStateEnum.properties[name].routeName,
        query: this.$route.query,
        params: this.$route.params
      });
    },
    resetPageHeader() {
      this.breadcrumbs = [{ title: "Threats" }, { title: "Progressions" }];
    }
  },
  computed: {
    isTrailsLoading() {
      return this.trailsinfoReqStatus === "loading" || this.mitigatedTrailsReqStatus === "loading";
    },
    ...mapGetters(["trailsinfoReqStatus", "mitigatedTrailsReqStatus", "trailProgressionDateRangeUserSetting"])
  },
  components: { PageHeaders, DateRangeDropdown }
};
</script>

<style scoped>
@import "assets/styles/_variables.css";

.page-toolbar-filter {
  margin-top: -10px;
  height: 48px;
  border-bottom: 2px solid #e4e7ed;
}

.el-button:not(.active) {
  background-color: white;
  color: var(--text-color-accent);
}
</style>



// WEBPACK FOOTER //
// src/views/monitor/cyber_attacks/BaseCyberAttacks.vue